// ============================================
// PERSONALITY TRAIT COLORS (DCTOS Framework)
// ============================================
// D = Drive (Drive) - How you approach challenges
// C = Connection (Connection) - How you interact with others
// T = Task (Task) - How you respond to pace
// O = Order (Order) - How you follow rules/procedures
// S = Style (Style) - How you make decisions
// ============================================

// Aurora Palette - Northern lights inspired
export const TRAIT_COLORS = {
  dominance: '#FB923C',     // D (Drive): Orange
  extraversion: '#E879F9',  // C (Connection): Fuchsia
  patience: '#22D3EE',      // T (Task): Cyan
  formality: '#4ADE80',     // O (Order): Green
  objectivity: '#CBD5E1',   // S (Style): Light Slate
} as const;

export const TRAIT_NAMES = {
  D: 'Drive',
  C: 'Connection',
  T: 'Task',
  O: 'Order',
  S: 'Style',
} as const;

// Map letter codes to colors (DCTOS)
export const getTraitColor = (letter: 'D' | 'C' | 'T' | 'O' | 'S'): string => {
  const colorMap = {
    D: TRAIT_COLORS.dominance,
    C: TRAIT_COLORS.extraversion,
    T: TRAIT_COLORS.patience,
    O: TRAIT_COLORS.formality,
    S: TRAIT_COLORS.objectivity,
  };
  return colorMap[letter];
};
